import React from 'react';
import classnames from 'classnames';

import { isNumeric } from 'dpl/shared/form/utils';

import { SimilarBreedsBreederRowResource } from '../../constants/resource_types';
import SimilarBreedsBreederCard, {
  SimilarBreedsBreeder
} from './SimilarBreedsBreederCard';
import SimilarBreedsSection from './SimilarBreedsSection';

interface SimilarBreedsBreederListProps {
  breeders: SimilarBreedsBreederRowResource[];
  view: string;
  footer?: React.ReactNode;
  className?: string | null;
}

function distanceDescription(miles: number | null | undefined) {
  if (!isNumeric(miles)) {
    return null;
  }

  return `${miles} ${miles === 1 ? 'mile' : 'miles'} away`;
}

function toCardBreeder(
  row: SimilarBreedsBreederRowResource
): SimilarBreedsBreeder {
  return {
    ...row.breeder_profile,
    breed_id: row.breed?.id,
    breed_name: row.breed?.name,
    available_puppy_count: row.breeder_puppy_count,
    distance_description: distanceDescription(row.distance_in_miles),
    photographs: row.photographs
  };
}

/** Breeder-list arm: three nearby breeders, each with a strip of photos. */
export default function SimilarBreedsBreederList({
  breeders,
  view,
  footer = null,
  className = null
}: SimilarBreedsBreederListProps) {
  const cardBreeders = (breeders || []).map(toCardBreeder);

  if (!cardBreeders.length) {
    return null;
  }

  return (
    <SimilarBreedsSection
      className={classnames('pv4', className)}
      footer={footer}
    >
      <div className="SimilarBreedsBreederList flex flex-column gap-8">
        {cardBreeders.map((breeder, idx) => (
          <SimilarBreedsBreederCard
            key={breeder.id}
            breeder={breeder}
            position={idx + 1}
            view={view}
          />
        ))}
      </div>
    </SimilarBreedsSection>
  );
}
